import { Card } from "primereact/card";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Menu } from "primereact/menu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { TablaDinamica } from "../../../../components/TablaDinamica";
import { Panel } from "primereact/panel";
import { TabPanel, TabView } from "primereact/tabview";
import { InfoGeneralCliente } from "./Secciones/InfoGeneralCliente";
import { DeclaracionCliente } from "./Secciones/DeclaracionCliente";
import { InfoFinancieraReferencia } from "./Secciones/InfoFinancieraReferencias";
import { InfoLaboralPatrimonio } from "./Secciones/InfoLaboralPatrimonio";
import { Button } from "primereact/button";
import * as generic from "../../../../components/Generico";
import { Dialog } from "primereact/dialog";
import { AnexosComponent } from "../../../../components/AnexosComponent";
import { ClientePj } from "../../../../models/trust/clientepj/ClientePj";
import { useEffect, useRef, useState } from "react";
import { ClientePjService } from "../../../../service/trust/ClientePjService";
import { useToken } from "../../../../components/useToken";
import { useLazyParams } from "../../../../hooks/useLazyParams";
import { Column } from "primereact/column";
import { DomicilioFiscal } from "./Secciones/DomicilioFiscal";
import { CertificacionSociedad } from "./Secciones/CertificacionSociedad";
import { GestorAnexosArbol } from "./GestorAnexosArbol";
import { DialogInstrucciones } from "../../../../components/ui/DialogInstrucciones";
import { set } from "date-fns";

export const InfoClientePj = () => {
    const [catalogos, setCatalogos] = useState(null);
    const omodel = new ClientePj({ formularioMatriz: catalogos?.formularioMatriz });
    const toast = useRef(null);
    const clientePjServicio = new ClientePjService();
    const { getPerss, getRol } = useToken();
    // Estados Globales del Formulario
    const [cliente, setCliente] = useState(null);
    const [permss, setPermss] = useState(null);
    // Estados de navegación y UI
    const [dialogCliente, setDialogCliente] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [siCliente, setSiCliente] = useState(false);
    const [urls, setUrls] = useState(null);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);
    const topRef = useRef(null);
    const [mostrarRegresarFlotante, setMostrarRegresarFlotante] = useState(false);
    const [dialogInstruccion, setDialogInstruccion] = useState(false);
    const [soloLectura, setSoloLectura] = useState(false);
    const [soloLecturaCert, setSoloLecturaCert] = useState(false);
    const [dialogArbolAnexos, setDialogArbolAnexos] = useState(false);
    const [opcion, setOpcion] = useState(null);

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/trust/cliente-pj',
            urlDownload: 'ficha/trust/cliente-pj/descarga',
            urlUpload: 'ficha/trust/cliente-pj/store',
            udelete: 'ficha/trust/cliente-pj/eliminar-anexo',
            uenviar: 'ficha/trust/cliente-pj/enviar',
            uaprobar: 'ficha/trust/cliente-pj/aprobar',
        });

        const permisosToken = getPerss();
        const esClienteNotificado = permisosToken !== undefined;
        setSiCliente(esClienteNotificado);
        if (esClienteNotificado) {
            setPermss(permisosToken);
            editFicha(true);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const esClienteNotificado = getPerss() !== undefined;
        if (!esClienteNotificado) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setMostrarRegresarFlotante(!entry.isIntersecting);
            },
            { threshold: 0 }
        );
        const currentRef = topRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [dialogCliente]);


    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            tablaEstado.setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }
        clientePjServicio.getLista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const iniciarNuevo = () => {
        setSoloLectura(false);
        setDialogCliente(true);
        setCliente(null);
        setActiveIndex(0);
        setDialogInstruccion(true);
    }

    const editFicha = (esNotificado = false, isReadOnly = false) => {
        const idConsulta = esNotificado ? 0 : cliente?.id;
        const necesitaCatalogos = catalogos === null;

        clientePjServicio.consultarCliente(idConsulta, { necesitaCatalogos: necesitaCatalogos }).then(res => {
            if (necesitaCatalogos && res.data.catalogos) {
                setCatalogos(res.data.catalogos);
            }
            if (!res.data.cliente) {
                iniciarNuevo();
                return;
            }
            // Evaluamos ambos nemónicos
            const formEnviado = ['ENVIADO', 'FINALIZADO'].includes(res.data.cliente?.nemonico);
            const certEnviado = ['ENVIADO', 'FINALIZADO'].includes(res.data.cliente?.nemonico_certificacion);

            // Asignamos los bloqueos independientemente
            setSoloLectura(isReadOnly || (esNotificado && formEnviado));
            setSoloLecturaCert(isReadOnly || (esNotificado && (formEnviado || certEnviado)));

            setDialogCliente(true);
            setActiveIndex(0);
            setDialogInstruccion(true);

            nuevoCliente({
                id: res.data.cliente.id,
                nemonico: res.data.cliente.nemonico,
                necesita_ac_sociedades: res.data.cliente.necesita_ac_sociedades,
                nemonico_certificacion: res.data.cliente.nemonico_certificacion
            });
        }).finally(() => {

        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el formulario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteCliente()
        });
    }

    const deleteCliente = () => {
        clientePjServicio.eliminarCliente(cliente.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    // FUNCIÓN VITAL. Actualiza el estado global del cliente actual en el formulario.
    const nuevoCliente = (nuevo) => {
        // Si se envía null, limpiamos el estado por completo.
        if (!nuevo) {
            setCliente(null);
            return;
        }
        // Usamos el callback (prev => ...) propio de React.
        // Con el spread operator (...prev, ...nuevo):
        // - Mantemos la base limpia que inyectó la tabla (rowData).
        // - Agregamos o actualizamos SOLO lo que necesitamos (ej. nemonico, necesita_ac_sociedades)
        setCliente(prev => ({ ...prev, ...nuevo }));
    }

    const handleNext = () => { if (activeIndex < 4) setActiveIndex(activeIndex + 1); };
    const handlePrev = () => { if (activeIndex > 0) setActiveIndex(activeIndex - 1); };

    const regresar = () => {
        setActiveIndex(0);
        setDialogCliente(false);
        setSoloLectura(false);
        if (!siCliente) loadLazyData();
    }

    const reiniciar = () => {
        if (!siCliente) loadLazyData();
        setDialogCliente(false);
        setDialogAnexos(false);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.consultar) {
            items.push({ label: 'Ver', icon: 'pi pi-eye', command: () => { editFicha(false, true); } });
        }
        if (permss?.actualizar && (cliente?.nemonico === 'BORRADOR' || cliente?.nemonico === 'ENVIADO')) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        }
        if (permss?.consultar) items.push({ label: 'Anexos Formulario', icon: 'pi pi-folder-open', command: () => { setDialogAnexos(true) } });

        if (permss?.consultar) items.push({ label: 'Anexos Autocertificaciones', icon: 'pi pi-sitemap', command: () => { setDialogArbolAnexos(true); } });

        if (permss?.eliminar && cliente?.nemonico === 'BORRADOR') {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setCliente(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    const panelHeaderTemplate = (options) => (
        <div className="p-panel-header flex justify-content-between align-items-center flex-wrap gap-2 w-full">
            <div>
                <h3 className="m-0 text-xl font-bold p-text-secondary flex align-items-center">
                    <i className="pi pi-building mr-2"></i>
                    <span className="mr-2">{cliente?.id ? 'EDITAR' : 'NUEVO'} FORMULARIO DE INFORMACIÓN DEL CLIENTE PERSONA JURÍDICA</span>
                    <Button type="button" icon="pi pi-question-circle" className="p-button-rounded p-button-text p-button-sm p-0 m-0 text-white hover:text-blue-200 transition-colors transition-duration-200"
                        style={{ width: '2rem', height: '2rem' }} onClick={() => setDialogInstruccion(true)} tooltip="Ver instrucciones" tooltipOptions={{ position: 'right' }} />
                </h3>
            </div>
            {!siCliente && (
                <Button tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} icon="pi pi-arrow-left" onClick={regresar} />
            )}
        </div>
    );

    const handleCertificacionEnviada = () => {
        if (siCliente) setSoloLecturaCert(true); // Bloqueamos la pestaña de certificación
        setActiveIndex(4); // Movemos al usuario a la Sección 5 (Índice 4) donde está el envío de momento
        toast.current?.show({ severity: 'info', summary: 'Paso completado', detail: 'Certificación enviada. Por favor, revise y envíe el Formulario principal.', life: 5000 });
    };

    return (
        <>
            <ConfirmDialog className="dialog-personalizado" />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />

            {!dialogCliente && !siCliente && (
                <div className="fadein animation-duration-300">
                    <Toolbar className="mb-4 shadow-1 border-round" start={generic.leftToolbarTemplate(iniciarNuevo, '', permss)} end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_cliente_pj', 'LISTADO CLIENTE PJ')} />
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
                    </Card>
                </div>
            )}

            {dialogCliente &&
                <div className="fadein animation-duration-300">
                    <Panel headerTemplate={panelHeaderTemplate} className="panel-ficha shadow-2">
                        <div ref={topRef} style={{ position: 'absolute', top: '0', left: '0', width: '1px', height: '80px', pointerEvents: 'none', visibility: 'hidden' }} />
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="form-tabview">

                            <TabPanel header="Sección 1" leftIcon="pi pi-id-card mr-2" disabled={cliente == null}>
                                <InfoGeneralCliente handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} catalogos={catalogos} toast={toast} nuevoCliente={nuevoCliente}
                                    id={cliente?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 2" leftIcon="pi pi-briefcase mr-2" disabled={!cliente?.id}>
                                <InfoLaboralPatrimonio handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} catalogos={catalogos} toast={toast} nuevoCliente={nuevoCliente}
                                    id={cliente?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 3" leftIcon="pi pi-chart-bar mr-2" disabled={!cliente?.id}>
                                <InfoFinancieraReferencia handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} catalogos={catalogos} toast={toast} nuevoCliente={nuevoCliente}
                                    id={cliente?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 4" leftIcon="pi pi-file-check mr-2" disabled={!cliente?.id}>
                                <DeclaracionCliente handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} catalogos={catalogos} toast={toast} nuevoCliente={nuevoCliente}
                                    id={cliente?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 5" leftIcon="pi pi-globe mr-2" disabled={!cliente?.id}>
                                <DomicilioFiscal handlePrev={handlePrev} permss={permss} catalogos={catalogos} toast={toast}
                                    nuevoCliente={nuevoCliente} id={cliente?.id} setDialogAnexos={setDialogAnexos}
                                    soloLectura={soloLectura} />
                            </TabPanel>
                            {cliente?.necesita_ac_sociedades === true && (
                                <TabPanel header="Auto-certificación Sociedades" leftIcon="pi pi-file-check mr-2" disabled={!cliente?.id}>
                                    <CertificacionSociedad handleNext={handleNext} handlePrev={handlePrev}
                                        permss={permss} cliente={cliente} catalogos={catalogos} toast={toast}
                                        nuevoCliente={nuevoCliente} id={cliente?.id} siCliente={siCliente} urls={urls}
                                        setDialogCliente={setDialogCliente} setDialogAnexos={setDialogAnexos} loadLazyData={loadLazyData}
                                        reiniciar={reiniciar} soloLectura={soloLecturaCert}
                                        onCertificacionEnviada={handleCertificacionEnviada} />
                                </TabPanel>
                            )}

                        </TabView>
                    </Panel>

                    {mostrarRegresarFlotante && !siCliente && (
                        <div className="fadein scalein" style={{ position: 'fixed', top: '65px', right: '30px', zIndex: 999 }}>
                            <Button icon="pi pi-arrow-left" onClick={regresar} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} />
                        </div>
                    )}
                </div>
            }

            <DialogInstrucciones visible={dialogInstruccion} onHide={() => setDialogInstruccion(false)} title={omodel.titulo} items={omodel.pasosInstrucciones} />
            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="clientePjTf" urls={urls} idp={cliente?.id} toast={toast} permss={permss} setDialogSubir={setDialogAnexos} reiniciar={reiniciar} 
                    estado={cliente?.nemonico} soloLectura={soloLectura} opcion={opcion} />
            </Dialog>

            <GestorAnexosArbol visible={dialogArbolAnexos} onHide={() => setDialogArbolAnexos(false)} clipjId={cliente?.id} toast={toast} permss={permss} />
        </>
    );
}